import { Component, OnInit } from '@angular/core';
import { Currency } from 'src/app/models/currencies/currency';
import { CategoriesService } from 'src/app/services/categories/categories.service';

@Component({
  selector: 'app-manage-currencies',
  templateUrl: './manage-currencies.component.html',
  styleUrls: ['./manage-currencies.component.scss'],
})
export class ManageCurrenciesComponent implements OnInit {
  allCurrencies: Currency[] = [];
  newCurrency: Currency = new Currency();
  currencyToDelete: Currency;
  constructor(private categoriesService: CategoriesService) {}

  ngOnInit(): void {
    this.getCurrencies();
  }

  getCurrencies() {
    this.categoriesService.getCurrencies().subscribe((data) => {
      this.allCurrencies = data.currencies;
      console.log(this.allCurrencies);
    });
  }

  saveNewCurrency() {
    if (this.newCurrency.currency != '' && this.newCurrency.currency != '') {
      this.allCurrencies.push(this.newCurrency);
      this.newCurrency = new Currency();
      this.updateCurrencies();
    }
  }

  setCurrencyToDelete(currency: Currency) {
    this.currencyToDelete = currency;
  }

  deleteCurrency(currency: Currency) {
    this.allCurrencies = this.allCurrencies.filter(
      (obj) => obj.symbol != currency.symbol
    );
    this.updateCurrencies();
  }

  updateCurrencies() {
    this.categoriesService.updateCurrencies(this.allCurrencies).subscribe(() => {
      this.getCurrencies();
    });
  }
}
